import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { MonthWiseAttendanceDetailsDto } from './month-wise-attendance-details-dto';

export class MonthWiseAttendanceResponse extends GlobalResponseObject{
    data?: MonthWiseAttendanceDetailsDto[];
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: MonthWiseAttendanceDetailsDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

